import React, { useEffect, useState } from "react";
import { PeekButton, PeekDialog, PeekDialogContent, PeekDialogActions, PeekTypography, PeekStack, PeekTextField, } from "@piiqtechnologies/ui-components";
import { useDeletePolicy, useNotification, useRefetch, useLoader, useError, useAnalytics, } from "@piiqtechnologies/ui-lib";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
const DELETE_CONFIRM_KEY = "delete";
export const DeletePolicy = ({ policyId, onClose }) => {
    const [deletePolicy, policyDeleted, deletePolicyInProgress, deletePolicyError] = useDeletePolicy();
    const { setNotification } = useNotification();
    const analytics = useAnalytics();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { setRefetch } = useRefetch();
    const intl = useIntl();
    const [deleteKey, setDeleteKey] = useState("");
    const onChangeDeleteKey = (event) => {
        setDeleteKey(event.target.value);
    };
    const onDelete = () => {
        deletePolicy(policyId);
    };
    useEffect(() => {
        setLoader(deletePolicyInProgress);
        return () => setLoader(false);
    }, [deletePolicyInProgress]);
    useEffect(() => {
        if (deletePolicyError) {
            setError(deletePolicyError === null || deletePolicyError === void 0 ? void 0 : deletePolicyError.message);
        }
    }, [deletePolicyError]);
    useEffect(() => {
        if (policyDeleted) {
            setRefetch();
            analytics.track("Policy Deleted");
            setNotification(intl.formatMessage(messages.deletePolicySuccess));
            onClose();
        }
    }, [policyDeleted]);
    return (React.createElement(PeekDialog, { disablePortal: true, maxWidth: "sm", hasCloseIcon: true, title: intl.formatMessage(messages.deletePolicyTitle), open: true, onClose: onClose },
        React.createElement(PeekDialogContent, null,
            React.createElement(PeekStack, { spacing: 1 },
                React.createElement(PeekTypography, { variant: "body1" }, intl.formatMessage(messages.deletePolicyDescription, { deleteKey: DELETE_CONFIRM_KEY })),
                React.createElement(PeekTextField, { variant: "standard", value: deleteKey, onChange: onChangeDeleteKey, InputLabelProps: { required: true }, InputProps: {
                        placeholder: DELETE_CONFIRM_KEY,
                        disableUnderline: true,
                        "aria-label": DELETE_CONFIRM_KEY,
                    } }))),
        React.createElement(PeekDialogActions, null,
            React.createElement(PeekButton, { fullWidth: true, size: "large", disabled: deleteKey !== DELETE_CONFIRM_KEY, onClick: onDelete, color: "error", variant: "contained" }, intl.formatMessage(messages.delete)))));
};
export default DeletePolicy;
